import React  from 'react';
import Iframe from 'react-iframe';
import { useContext } from 'react'
import AuthContext from './AuthContext';


const Home_en = () => {
  const {gclang,setgclang} = useContext(AuthContext);  
  setgclang((a) => ('en')); 
            
  return (
    <div className='container-fluid mt-4'>
       
    <Iframe url="./annouceEN.htm"
                 position="absolute"
                 width="100%"                
                 height="100%"
                
     />
     
    
    </div>
  )
}

export default Home_en





